
import { Vue, Options } from "vue-class-component";
import axios from "axios";
let config = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("jwt"),
  },
};

const dateFormatter = (date: string) => {
  let d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  let year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

@Options({
  mounted() {
    this.$store.dispatch("Booking/getTickets");
    axios
      .get("https://bookinga.herokuapp.com/api/v1/ticket/used", config)
      .then((res) => {
        if (res.data.ticket == undefined) {
          this.para = res.data.message;
        } else {
          this.used = res.data.ticket;
          for(let i=0;i<this.used.length;i++){
            this.used[i].date = dateFormatter(this.used[i].date);
          }
          let noticket = document.querySelector(".no-ticket");
          noticket?.setAttribute("hidden", "true");
        }
      });
  },
})
export default class Alltickets extends Vue {
  data() {
    return {
      used: [],
      para: "",
    };
  }
}
